module.exports = __webpack_public_path__ + "media/tase/bghead-184746fb.png";